import React , { useState, useEffect,useContext } from "react";
import InputField from 'components/UI/Input/InputField';
import { Table, Row, Col} from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import useValidator from 'hooks/useValidator';

import ButtonField from '../../components/UI/Button/ButtonField';
import { isEmpty } from 'components/Login/validator';
import BeatLoader from "react-spinners/BeatLoader";
import Cookies from 'universal-cookie'; 
import swal from 'sweetalert';
import { WizardDataContext } from "context/WizardDataContext";
import { getWizardDataService } from "services/wizardDataService";
import { customStep } from "constants/staticVariables";
const cookies = new Cookies();

function Step1(props) { 
  const {setHasError} = props;
  let arrayConvert = [];
  const { t, i18n } = useTranslation();
  const [validator, showValidationMessage] = useValidator();

  let uniq;
  let [unique, setUnique] = useState([]);
  let [tempImg, setTempImg] = useState();
  const [wizardData, setWizardData] = useContext(WizardDataContext)
  const [isNewApi, setIsNewApi] = useState(false)
  const [selectedImages, setSelectedImages] = useState([]);
  const [getNewApi, setGetNewApi] = useState()
  const [newURL, setNewURL] = useState({})
  const [newGetApiResponse, setNewGetApiResponse] = useState()
  const [productTypeValue, setProductTypeValue] = useState(null);

  const urlhost = window.location.host;
  const domain = urlhost.split('.');
  const subDomain = domain[1] +"."+ domain[2];
  const baseURL = domain[0] === "product-stg" ? "https://product-stg.eseal.io:5003/" : `https://login-stg.${subDomain}:3003`
  const initialState = {
    inheritRoles: 
      { 
        elementType: 'select',
        elementConfig: 
         { options: [
              { value: null, displayValue: `${t("please_select")}` },
              { value: 'Assemble Manager', displayValue: 'Assemble Manager' },
              { value: 'Warehouse Manager', displayValue: 'Warehouse Manager' } 
            ] 
          },
        id: 'inheritRoles',
        value: null,
        label: `${t("inherit_form")}`,
        validate: { required: false, rules: 'required' },
        update: 
          { 
           required: true,
           endPoint: `${baseURL}/role-management/get-inheritroledetails` 
          } 
      },
    name: 
      { 
        elementType: 'input',
        elementConfig: { type: 'text', placeholder: `${t("role_name")}` },
        id: 'name',
        value: null,
        label: `${t("role_name")}*`,
        validate: { required: true, rules: 'required' },
        update: { required: false } ,             


      },

    description: 
      { 
        elementType: 'textareaWithoutMandatory',
        elementConfig: { type: 'textarea', placeholder: 'Description' },
        id: 'description',
        value: null,
        label: `${t("description")}`,
        validate: { required: true, rules: 'required' },
        update: { required: false } 
      },
     active: 
      { 
        elementType: 'checkbox',
        elementConfig: { type: 'checkbox', placeholder: '' },
        id: 'active',
        value: true,
        label: `${t("active")}*`,
        validate: { required: true, rules: 'required' },
        update: { required: false } 
      },
      ...cookies.get('customer_id') === '12' && {
      all_reports:
    {
      elementType: "checkbox",
      elementConfig: { type: "checkbox", placeholder: ''},
      id: "all_reports",
      value: false,
      label: "Report Analyst *",
      validate: { required: true, rules: "required" },
      update: { required: false }
    }
  }
 
  };
const root = document.documentElement;
const buttonBackgroundColor = getComputedStyle(root).getPropertyValue('--button_background-color').trim();
const buttonTextColor = getComputedStyle(root).getPropertyValue('--button_text-color').trim();

  const initialValue = [{displayValue: `${t('please_select')}`, value: ''}];
  let inputFile = document.getElementById('files1')
  let [formValuesUpd, setFormValuesUpd] = useState(null);
  let [formValuesUpdBackCheck, setFormValuesUpdBackCheck] = useState();
  let [capacity, setCapacity] = useState();
  let [sizeInMB, setSizeInMB] = useState()
  // let [UOM, setUOM] = useState();
  let [level, setLevel] = useState();
  let [tableList, setTableList] = useState([]);
  let [tdData, setTdData] = useState([]);
  let [tdDataParent, setTdDataParent] = useState([]);
  let [finalValue, setFinalValue] = useState();
  let [formValues, setFormValues] = useState([]);
  let [SelectChildValueCheckbox, setSelectChildValueCheckbox] = useState();
  let formElementsArray = [];
  let [visible, setVisible] = useState(false);
  let [show,setShow] = useState(false);
  let [toggle,setToggle] = useState(false);
  let searchFormData = {};
  let [loadSForm, setloadSForm] = useState(false);
  let [selectedFile, setSelectedFile] = useState(null); 
  let commonParams = {
    customer_type:cookies.get('customer_type'),
    customer_id:cookies.get('customer_id'),
    user_id:cookies.get('user_id')
  }
  const addTableData = (upd) => {
    try{
    if(tdData['level'] !==  `${t("please_select")}`)  {
      if(props.validator.allValid()) {
        let obj;
        obj = Object.keys(wizardData.productsView.data).forEach((el) => {
          if (el === 'level') {
            if(formValuesUpd != undefined || formValuesUpd != null){
              formValuesUpd[el].elementConfig.options.forEach((level) => {
                if (level.displayValue === tdData['level']) {
                    tdData = {...tdData,'level_id': level.value} 
                  }
              })
            }
        }          
        })
        const someProperty = {...formValuesUpd}
        Object.keys(someProperty).forEach(el => {
          // if(el === 'level')
          someProperty[el].value = '';
        })
        Object.keys(tdData).forEach(el => {
          if(!tdData['is shipper pack']) 
          tdData = {...tdData,'is shipper pack': 'false'} 
          if(!tdData['is pallet']) 
          tdData = {...tdData,'is pallet': 'false'} 
        })
        setTableList(tableList => tableList.concat(tdData));
        // props.setTdDataParent(unique => unique.concat(tdData));
        setTdData([]);
      }
      else 
        props.showValidationMessage(true);
    } else 
        swal({
          title:`${t("alerts.choose_valid_level")}`,
          text: `${t("alerts.please_cannot_be_selected")}`,
          icon:"warning",
          button:`${t("alerts.ok")}`
          })
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  let  deleteHandler = (image) => {
    try{
    setSelectedImages(selectedImages.blobFile.filter((e) => e !== image));
    if(inputFile?.value){
    inputFile.value = ''
    }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  const fileUpload= (files) => {
    setSelectedFile(files)
  }
  const fileUpload1= e => {
    try{
    e.preventDefault();
    let reader = new FileReader();
    let file = selectedFile;
    reader.onloadend = () => {
      // this.setState({E
      //   file: file,
      //   imagePreviewUrl: reader.result
      // });
    }
   reader.readAsDataURL(file);
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  let ProductManagementFeature = (event,inputIdentifier) => {
    try{
    const updateOrderForm = {
      ...formValuesUpd
    }
    const updateElementForm = { 
      ...updateOrderForm[inputIdentifier]
    }
    if (props.titlePreFix === `${t('add')}` || props.titlePreFix === `${t('edit')}`) {
      formElementsArray.forEach(function(formElement, indexIdx){
      if(props.currentStep === 3){
        if(updateElementForm.label === 'Gift-Box Weight*'){
          if(event.target?.value.length > 0){
          if(formElement.id === "field2" || formElement.id === "field3" || formElement.id === "field4"){
          formElement.config.validate.required = true
        }
      }
      if (event.target?.value.length == 0){
        if(formElement.id === "field2" || formElement.id === "field3" || formElement.id === "field4"){
          formElement.config.validate.required = false
        }
      }
      }
    }
  })
  }
    updateOrderForm[inputIdentifier] = updateElementForm;  
    setFormValuesUpd(updateOrderForm);
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  async function inputWizardChangedHandler(event,inputIdentifier) {
    try{
    ProductManagementFeature(event,inputIdentifier)
    const updateOrderForm = {
      ...formValuesUpd
    }
    const updateElementForm = { 
      ...updateOrderForm[inputIdentifier]
    }
    props.setSelectedCombo({visible,toggle,show}) ;
    if(updateOrderForm[inputIdentifier].elementType === 'multiselect') {
      if(Array.isArray(event) && event.length !== 0){
        updateElementForm.value = event;
      } 
      else
        updateElementForm.value = null;
    }
    else if(updateOrderForm[inputIdentifier].elementType === 'selectshowsearch' ) {
      if(event && event.length !== 0){
        updateElementForm.value = event;
      } 
      else
        updateElementForm.value = null;
    }
    else if((updateOrderForm[inputIdentifier].elementType === 'file')) {
        if(event.target.files[0])
        {
          const selectedFiles = event.target.files[0];
          const selectedFilesArray = [URL.createObjectURL(selectedFiles)];
          setSelectedImages({
            blobFile:selectedFilesArray,
            name: event.target.files[0].name});
          let reader = new FileReader();
          let file = event.target.files[0];
          setSizeInMB(((file.size) / (1024*1024)).toFixed(2));
          if(wizardData.productsDetail){
            wizardData.productsDetail.data.data1.imgurl = event.target.files[0].name;
            setWizardData(wizardData);
          }
          if(sizeInMB > 1)
            return swal({
              title:`${t("alerts.upload_image")}`,
              icon:"warning",
               button:`${t("alerts.ok")}`
              })       
          props.setImageBinary(file.name);
          props.setImageSize(file.size);
          reader.onloadend = () => {
            props.setImageData(reader.result);
          }
          if(file.type === "image/png" || file.type === "image/jpeg"){
            reader.readAsDataURL(file);
            setTempImg(URL.createObjectURL(event.target.files[0]));
          }else{
            return swal({
              title:`${t("alerts.upload_image_with.png")}`,
              icon:"warning",
               button:`${t("alerts.ok")}`
              })
          }
        }
    }
    else if(event.target.type === 'checkbox')
    {
      updateElementForm.value = event.target.checked ? 1 : 0 
    }
    else if(event.target.type === 'select-one')
    {      
      if(updateOrderForm[inputIdentifier].update.required === true) {
        if(event.target.value)
        {       
          setIsNewApi(true)   
          let keyName = (inputIdentifier === 'inheritRoles') ? 'id' : inputIdentifier;
          let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+keyName+'='+event.target.value;
          const commanParamVal = new URLSearchParams(commonParams);
          let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
          updateElementForm.value = event.target.value;
          updateOrderForm[inputIdentifier] = updateElementForm; 
          setFormValuesUpd(updateOrderForm);
          setNewURL({
            url: newgetURL,
            updateOrderForm: updateOrderForm
          }) 
        }else {
          updateElementForm.value = event.target.value;
          updateOrderForm[inputIdentifier] = updateElementForm;  
          setFormValuesUpd(updateOrderForm);
        }
    }
    else {
      if(event.target.value !== `${t("please_select")}`){
        updateElementForm.value = event.target.value;
        const allowedProdTypes = ["8002","8003","8001"];
        if(cookies.get("customer_id") == 5 && (inputIdentifier === "product_type" && allowedProdTypes.includes(event.target.value))){
          updateOrderForm["component"].value = [];
          let options = [];
          if(event.target.value === "8003" || event.target.value === "8002" || event.target.value === "8001"){
          let semi_finsh = wizardData.productsView.data.component["8002"];
          let component = wizardData.productsView.data.component["8001"];
          options = [...semi_finsh,...component]
          }
          updateOrderForm["component"].elementConfig.options = options;
          setFormValuesUpd(updateOrderForm);
        }
      }
      else{
        updateElementForm.value = null;
      }
    }
  }
    else
    {
      if(event.target.value)
        updateElementForm.value = event.target.value;
      else
        updateElementForm.value = null;
    }
    updateOrderForm[inputIdentifier] = updateElementForm;  
    setFormValuesUpd(updateOrderForm);
    const val = updateElementForm.value;
    setTdData((tdData) => ({...tdData, [inputIdentifier]: val}));
    for (let inputIdentifier in updateOrderForm) {
      if(inputIdentifier === "component" && updateOrderForm["component"].value){
        updateOrderForm[inputIdentifier].value.map(function(fValue, indexId) {
          arrayConvert[indexId] = fValue.value;
        })
        searchFormData[inputIdentifier] = arrayConvert;
      }else{
        searchFormData[inputIdentifier] = updateOrderForm[inputIdentifier].value;
      }
    }
    props.setFormValues((formValues) => ({...formValues, ...searchFormData}));   
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  
  // const updateDropDwon = (URL, FormVal) => {
 async function updateDropDwon(URL, FormVal){ 
  try{
    const updateForm = {
      ...FormVal
    }
    if(newGetApiResponse || wizardData.productsDetail ){
    let dropVal,dropValLoc,dropValComp,dropValCategory;
    if(isNewApi ? newGetApiResponse && newGetApiResponse.data.data1 : wizardData.productsDetail.data.data1){
        dropVal = {
          ...getNewApi ?newGetApiResponse && newGetApiResponse.data.data1 : wizardData.productsDetail.data.data1
        } 
    }
    if(getNewApi ? newGetApiResponse && newGetApiResponse.data.data3 : wizardData.productsDetail.data.data3) {
      dropValLoc = {
        ...getNewApi ? newGetApiResponse && newGetApiResponse.data.data3 : wizardData.productsDetail.data.data3
      }
    } 
    if( getNewApi ?newGetApiResponse && newGetApiResponse.data.data4 : wizardData.productsDetail.data.data4) {
      dropValComp = {
        ...getNewApi ? newGetApiResponse && newGetApiResponse.data.data4 : wizardData.productsDetail.data.data4
      }
    if(getNewApi ? newGetApiResponse && newGetApiResponse.data.data5 : wizardData.productsDetail.data.data5){
      dropValCategory = {
        ...getNewApi ?newGetApiResponse && newGetApiResponse.data.data5 : wizardData.productsDetail.data.data5
      }
    }
    }
    if(updateForm['category']&& wizardData.productsDetail.data?.data5){
      updateForm['category'].value  = dropValCategory['category']
    }  
    if(updateForm['inheritRoles'])
      updateForm['inheritRoles'].value = dropVal['role_id'];


    let obj;
    if(dropVal)
    {
      if(updateForm['c_state'] && dropVal['state']) {
        updateForm['c_state'].elementConfig.options = dropVal['state'];
        updateForm['c_state'].elementConfig.options.splice(0, 0, ...initialValue)
      }
      obj = Object.keys(dropVal).forEach((el) => {
      if(updateForm.hasOwnProperty(el)){
        if(updateForm[el].elementType == 'select' && Array.isArray(dropVal[el])) {
            updateForm[el].elementConfig.options = dropVal[el];
            updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
            updateForm[el].value=null;
        }
        else if(updateForm[el].elementType == 'multiselect') 
          updateForm[el].elementConfig.options = dropVal[el];
        else if(updateForm[el].elementType == 'selectshowlabel') 
          updateForm[el].elementConfig.options = dropVal[el];
        else if(updateForm[el].elementType == 'input'){
          if(dropVal[el] === 'Whitelist Admin'){
            updateForm[el].elementConfig.disable = true;
            updateForm[el].value = dropVal[el]
          }else{
            updateForm[el].elementConfig.disable = false;
            updateForm[el].value = dropVal[el]
          }
        }
          else
          updateForm[el].value = dropVal[el]
        }
      })
    }
    if(getNewApi ? newGetApiResponse && newGetApiResponse.data.data3 : wizardData.productsDetail.data.data3) {
      let obj1 = Object.keys(getNewApi ? newGetApiResponse && newGetApiResponse.data.data3 : wizardData.productsDetail.data.data3).forEach((el) => {
        if(updateForm.hasOwnProperty(el)){
          // if(!isEmpty(dropValLoc[el])){
            if(updateForm[el].elementType == 'multiselect') 
              updateForm[el].value = dropValLoc[el];
          // }
        }
      })
    }
    if(getNewApi ? newGetApiResponse && newGetApiResponse.data.data4 : wizardData.productsDetail.data.data4) {
      let obj1 = Object.keys(getNewApi ? newGetApiResponse && newGetApiResponse.data.data4 : wizardData.productsDetail.data.data4).forEach((el) => {
        if(updateForm.hasOwnProperty(el)){
            if(updateForm[el].elementType == 'multiselect') 
              updateForm[el].value = dropValComp[el];
        }
      })
    }
    if(getNewApi ? newGetApiResponse && newGetApiResponse.data.data1.hasOwnProperty('feature_id') === true : wizardData.productsDetail.data.data1.hasOwnProperty('feature_id') === true) {
      if(getNewApi ? newGetApiResponse && newGetApiResponse.data.data1 : wizardData?.productsDetail.data.data1.feature_id !== null)
        props.setSelectChildValueCheckbox(dropVal.feature_id.split(','))
    }
    if(props.titlePreFix === `${t('edit')}` && getNewApi ? newGetApiResponse?.data.hasOwnProperty('userInfo') === true : wizardData?.productsDetail?.data.hasOwnProperty('userInfo') === true) {
      if(getNewApi ? newGetApiResponse && newGetApiResponse.data : wizardData.productsDetail.data.userInfo)
        props.setSelectChildValue(getNewApi ? newGetApiResponse && newGetApiResponse.data : wizardData.productsDetail.data.userInfo)
    }
    if(getNewApi ? newGetApiResponse && newGetApiResponse.data.data2 : wizardData.productsDetail.data.data2)
      setTableList(getNewApi ? newGetApiResponse && newGetApiResponse.data.data2 : wizardData.productsDetail.data.data2);
      for (let inputIdentifier in updateForm) {
        searchFormData[inputIdentifier] = updateForm[inputIdentifier].value;
      }
      props.setFormValues((formValues) => ({...formValues, ...searchFormData}));
      props.setTdDataParent(getNewApi ? newGetApiResponse && newGetApiResponse.data.data2 : wizardData.productsDetail.data.data2);
      // if(getdrpdwnresponseJson) {
    setFormValuesUpd(updateForm);
      setloadSForm(false);
      // }
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

const getStatesData = async () => {
  try{
    const getdrpdwnresponseJson = await getWizardDataService(newURL.url);
    setNewGetApiResponse(getdrpdwnresponseJson)
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
useEffect(() => {
  if(isNewApi == true){
    getStatesData()
  }
},[newURL])

useEffect(() => {
  try{
  props.setSelectedCombo({visible,toggle,show}) ;
  setGetNewApi(isNewApi)
  if(isNewApi == true){
    updateDropDwon(newURL.url,newURL.updateOrderForm)
  }
}catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
},[isNewApi,newGetApiResponse])

  useEffect(() => {
    try{
    (async () => {
      setFormValuesUpdBackCheck(props.block.formValues);
      if(props.futurename === 'Role' && props.titlePreFix === `${t('add')}`){
      setFormValuesUpd(initialState);
      }
      else if (props.futurename === `${t('Product')}` && props.titlePreFix === `${t('add')}`|| props.titlePreFix === `${t('edit')}`) {
        Object.keys(props.block.formValues).forEach((el) => {
          if(el === 'field1' || el === 'field2' || el === 'field3' || el === 'field4') {
            props.block.formValues[el].validate.required = false
          }
        })
      }
      setFormValuesUpd(props.block.formValues);
      setFormValues(props.formValues);
      setTdDataParent(props.tdDataParent);
      if(props.dropDwnApi === 'not found' || props.dropDwnApi === undefined) {
        setloadSForm(false);
        if(props.titlePreFix === `${t('edit')}` ){
          setloadSForm(true)
          updateDropDwon(props.getDataURL, props.block.formValues);
        }
      }
      else{
        setloadSForm(true);
        // const getdrpdwnresponse = await FetchAPI(props.dropDwnApi);
        // const getdrpdwnresponseJson = await getdrpdwnresponse.json();
        // if(getdrpdwnresponseJson.status === 200){
        let updateForm;
        if(props.futurename === 'Role' && props.titlePreFix === `${t('add')}`) {
          updateForm = {
            ...initialState
          }
        }
        else {
          updateForm = {
            ...props.block.formValues
          }
        }
        const dropVal = {
          ...wizardData.productsView.data
        }
        let obj;
        obj = Object.keys(wizardData.productsView.data).forEach((el) => {
          if( updateForm.hasOwnProperty(el)){
            if(!isEmpty(dropVal[el])){
              if(updateForm[el].elementType == 'select'){
                updateForm[el].elementConfig.options = dropVal[el];
                updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
              }
              else if(updateForm[el].elementType == 'multiselect') {
                if(updateForm[el].id === "component" && cookies.get("customer_id") == 5){
                  updateForm[el].elementConfig.options = [...dropVal[el]["8001"], ...dropVal[el]["8002"]];
                }else{
                  updateForm[el].elementConfig.options = dropVal[el];
                }
              } 
              else if(updateForm[el].elementType == 'selectshowlabel') {
                updateForm[el].elementConfig.options = dropVal[el];
                updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
              }
              else if(updateForm[el].elementType == 'selectshowsearch') {
                updateForm[el].elementConfig.options = dropVal[el];
              }  
            }
          }
        })
        setFormValuesUpd(updateForm);
        setloadSForm(false);
        if(props.titlePreFix === `${t('edit')}` ){
          //setDuplicateCheck(true)
          setloadSForm(true);
          updateDropDwon(props.getDataURL, props.block.formValues);
        }
       
      }
    })()
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
  }, [wizardData])

  for (const key in formValuesUpd){
    formElementsArray.push({
      id: key,
      config: formValuesUpd[key]
    });
  }

  const editHeaders = ["level","capacity","uom","is shipper pack","is pallet"]
  function getKeysYML(){
    try{
    let permittedValues = [];
    // for (let i = 0; i < editHeaders.length; i++){
    // permittedValues[i] = editHeaders[i]["text"];
    // console.log("@134",permittedValues)
    // }
    if(props.block.headers)
     { 
      return Object.values(props.block.headers);}
    else
      return Object.values(editHeaders);
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  
  function getHeader(){
    let keys = getKeysYML();
    return keys.map((key, index)=>{
      // return i18n.language === "chi" ? <th key={key}>{key["text"].toUpperCase()}</th> : <th key={key}>{key.toUpperCase()}</th>
      return  <th key={key}>{t(key).toUpperCase()}</th>
    })
  }
  
  function getRowsData(){
    var items = unique;
    let keys = getKeysYML();
    return items.map((row, index)=>{
      return <tr key={index}><RenderRow key={index} data={row} keys={keys}/>
        <td>
        <button className="btnCls"
        style={{
          backgroundColor: buttonBackgroundColor,
          color: buttonTextColor,
          textAlign: 'center',
          minWidth:'70px'
      }}
      onClick={ () => deleteRow(index) }>{`${t('delete')}`}</button>
        </td>
      </tr>
    })
  }

  const RenderRow = (props) => {
    return props.keys.map((key, index)=>{
        // return i18n.language === "chi" ? <td key={props.data[key]} >{props.data[key["datafield"]]}</td> : <td key={props.data[key]} >{props.data[key]}</td> 
        return <td key={props.data[key]} >{props.data[key]}</td> 
    })
  }

  const deleteRow = (i) => {
    swal({
      title: `${t("alerts.sure")}`,
      text: `${t("alerts.deleted_not_recovered")}`,
      icon: "warning",
      buttons: [`${t('alerts.cancel')}`,
    `${t('alerts.ok')}`],
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        const newArr = [...unique];
        const toRemove =  newArr.splice(i, 1);
        const index = newArr.indexOf(toRemove);
        if (index > -1) { 
          newArr.splice(index, 1);
        }
        setTableList(newArr);
        props.setTdDataParent(newArr);
        swal(`${t('alerts.data_deleted')}`, {
          icon: "success",
          timer: 2000,
          button: false
        });
      } else {
        swal(`${t('alerts.data_safe')}`, {
          timer: 2000,
          button: false
        });
      }
    });
  }
  useEffect(() => {
    formElementsArray.forEach(formElement => {
      if(formElement.config.id === "product_type"){
        setProductTypeValue(formElement.config.value)
      }
    })
  },[formElementsArray])

  useEffect(() => {  
    try{
    // if(duplicateCheck == true) {     
    uniq = tableList && tableList.filter(function({level},index) {
    if(this[level] && (this[level] == tableList[tableList.length-1].level)) {
      props.setDuplicateCheck(true);
      swal({title:`${t("alerts.duplicate_values")}`, text:`${t("alerts.level_not_repeated")}`, icon:"error", button:`${t("alerts.ok")}`})
    }
    else 
      props.setDuplicateCheck(false);
    return !this[level] && (this[level] = level)
    }, {})
    props.setTdDataParent(uniq)
    if(Object.keys(tableList).length == 0)
      props.setDuplicateCheck(false);
    props.setParentTableLength(Object.keys(uniq).length)
    setUnique(uniq);
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
  }, [tableList]);

  if(props.currentStep !== props.block.step) {
    return null
  } 
  
  const showTable = () => {
    if(props.currentStep === 4 && !customStep.flag){
      return true
    }else if((cookies.get("customer_id") == 17 || cookies.get("customer_id") == 19) && props.currentStep === 3){
      return true
    }else{
      return false
    }
  }


  return(
    <div>
       { (loadSForm) &&
          <div style={{ textAlign: 'center', marginTop: '1%', position:'absolute', marginLeft:'44%' }}>
              <BeatLoader />
          </div>
        }
     {formElementsArray.map(function(formElement, indexIdx){
      let adjustHeightConditionally = props.futurename == 'Company' && props.block.step === 1 && formElement.config.elementType == "select"
       let RowData = 
       <div> 
        {formElement.config.elementType !== "checkbox" ? (
         <Col md="6" className={`mb-6`} 
         style={adjustHeightConditionally ? {marginTop:'22px', height:'100px'}:{ height: '82px' }} >
           <InputField
             key={formElement.id}
             elementType={formElement.config.elementType}
             elementConfig={formElement.config.elementConfig}
             value={(formElement.config.value == null) ? '' : formElement.config.value}
             labelName={formElement.config.label}
             id={formElement.config.id}
             isValidate={formElement.config.validate}
             changed={(event) => inputWizardChangedHandler(event, formElement.id)}
             validater={props.validator}
             imgSize={sizeInMB}
             uploadFunc={fileUpload1}
             fileUpload={fileUpload}
             tableList={tableList}
             level={level}
             deleteHandler={deleteHandler}
             setLevel={setLevel}
             capacity={capacity}
             setCapacity={setCapacity}
             // UOM={UOM}
             // setUOM={setUOM}
             tempImg={tempImg}
             setTempImg={setTempImg}
             imagePath={props.imagePath}
             titlePreFix={props.titlePreFix}
             visible={visible}
             setVisible={setVisible}
             show={show}
             selectedImages={selectedImages}
             setShow={setShow}
             toggle={toggle}
             setToggle={setToggle}
             wizardData={wizardData}
           />
         </Col>
         ) : (
             <Col md="2" className="mb-2" style={{ height: '82px' }}>
               <InputField
                 key={formElement.id}
                 elementType={formElement.config.elementType}
                 elementConfig={formElement.config.elementConfig}
                 value={(formElement.config.value == null) ? '' : formElement.config.value}
                 labelName={formElement.config.label}
                 id={formElement.config.id}
                 isValidate={formElement.config.validate}
                 changed={(event) => inputWizardChangedHandler(event, formElement.id)}
                 validater={validator}
                 titlePreFix={props.titlePreFix}
                 title={props.title}
                 wizardData={wizardData}
               />
             </Col>
             )}
           </div>;
        return (  
          <div>{RowData}</div>
        );
      })}

      {props.block.Table ?
        <Row className='d-flex align-items-center mb-4'>
          <div className='text-center mb-3 row'>
            <button 
              onClick={ () => addTableData(formValuesUpd) }
              class="btnCls"
              style={{
                backgroundColor: buttonBackgroundColor,
                color: buttonTextColor,
                fontSize: 'initial'
              }}
              >{`${t('add_table')}`}
            </button>
          </div>
        </Row>
      :''}
      {unique && unique.length> 0 && showTable() ?     
        <Table striped hover >
          <thead>
            <tr>{getHeader()}</tr>
          </thead>
          <tbody>    
            {getRowsData()}  
          </tbody>
        </Table>
      : ''}
    </div>
  );
}

export default Step1;  